import { parseISO, toISO } from "./format";

// returns {start, end, prevStart, prevEnd, label} as ISO strings (inclusive)
export function getPeriodRange(period, ref = new Date(), custom = null) {
  const today = new Date(ref.getFullYear(), ref.getMonth(), ref.getDate());
  const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  let start, end, label;
  end = startOf(today);

  if (period === "custom" && custom && custom.start && custom.end) {
    let cs = startOf(parseISO(custom.start));
    let ce = startOf(parseISO(custom.end));
    if (cs > ce) [cs, ce] = [ce, cs];
    start = cs;
    end = ce;
    const csISO = toISO(cs);
    const ceISO = toISO(ce);
    label = `Du ${csISO.split("-").reverse().join("/")} au ${ceISO
      .split("-")
      .reverse()
      .join("/")}`;
    const days = Math.round((end - start) / 864e5) + 1;
    const prevEnd = new Date(start.getTime() - 864e5);
    const prevStart = new Date(prevEnd.getTime() - (days - 1) * 864e5);
    return {
      start: toISO(start),
      end: toISO(end),
      prevStart: toISO(prevStart),
      prevEnd: toISO(prevEnd),
      label,
      days,
    };
  }

  switch (period) {
    case "today":
      start = startOf(today);
      label = "Aujourd'hui";
      break;
    case "7j":
      start = startOf(new Date(today.getTime() - 6 * 864e5));
      label = "7 derniers jours";
      break;
    case "30j":
      start = startOf(new Date(today.getTime() - 29 * 864e5));
      label = "30 derniers jours";
      break;
    case "month":
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      label = "Ce mois-ci";
      break;
    case "quarter": {
      const q = Math.floor(today.getMonth() / 3);
      start = new Date(today.getFullYear(), q * 3, 1);
      label = "Ce trimestre";
      break;
    }
    case "year":
      start = new Date(today.getFullYear(), 0, 1);
      label = "Cette année";
      break;
    case "all":
    default:
      start = new Date(2000, 0, 1);
      label = "Tout l'historique";
      break;
  }

  const days = Math.round((end - start) / 864e5) + 1;
  const prevEnd = new Date(start.getTime() - 864e5);
  const prevStart = new Date(prevEnd.getTime() - (days - 1) * 864e5);

  return {
    start: toISO(start),
    end: toISO(end),
    prevStart: toISO(prevStart),
    prevEnd: toISO(prevEnd),
    label,
    days,
  };
}

export function inRange(iso, start, end) {
  return iso >= start && iso <= end;
}

export function aggregate(sales) {
  const acc = {
    total: 0, total_carte: 0, total_especes: 0,
    total_sur_place: 0, total_a_emporter: 0,
    boissons_sur_place: 0, food_sur_place: 0,
    htva_total: 0, tva_12: 0, tva_21: 0, tva_6: 0, tva_totale: 0,
    count: sales.length,
  };
  for (const s of sales) {
    acc.total += s.total;
    acc.total_carte += s.total_carte;
    acc.total_especes += s.total_especes;
    acc.total_sur_place += s.total_sur_place;
    acc.total_a_emporter += s.total_a_emporter;
    acc.boissons_sur_place += s.boissons_sur_place || 0;
    acc.food_sur_place += s.food_sur_place || 0;
    acc.htva_total += s.htva_total;
    acc.tva_12 += s.tva_12;
    acc.tva_21 += s.tva_21 || 0;
    acc.tva_6 += s.tva_6;
    acc.tva_totale += s.tva_totale;
  }
  acc.average = acc.count ? acc.total / acc.count : 0;
  let best = null, worst = null;
  for (const s of sales) {
    if (!best || s.total > best.total) best = s;
    if (!worst || s.total < worst.total) worst = s;
  }
  acc.best = best;
  acc.worst = worst;
  return acc;
}
